import { useState } from "react";
import { Button, Modal, Stack, Text } from "@mantine/core";
import classes from "./ReservationPopup.module.scss";

interface MessengerPopupProps {
	chooseStoreOpened: boolean;
	onClose: () => void;
	onConfirm: (selectedValue: string | null) => void;
	message: string;
	confirmText?: string;
}

export default function MessengerPopup({
	chooseStoreOpened,
	onClose,
	onConfirm,
	message,
	confirmText,
}: MessengerPopupProps) {
	const [selectedValue] = useState<string | null>(null);
	return (
		<Modal.Root
			opened={chooseStoreOpened}
			onClose={onClose}
			centered
			zIndex={400}
			classNames={{ inner: classes.modalInner }}
		>
			<Modal.Overlay opacity={0.35} />
			<Modal.Content p="0" bg="white">
				<Modal.Header bg="white" py="0" mih="11.34vw">
					<Modal.CloseButton />
				</Modal.Header>
				<Modal.Body px="7.22vw" pb="7.58vw">
					<Stack gap="10.31vw">
						<Text size="4.64vw" ta="center">
							{message}
						</Text>
						<Button
							h="9.02vw"
							w="100%"
							color="black"
							onClick={() => onConfirm(selectedValue)}
						>
							{confirmText ?? "確認"}
						</Button>
					</Stack>
				</Modal.Body>
			</Modal.Content>
		</Modal.Root>
	);
}
